export default __webpack_public_path__ + "static/media/banner-image-3.15b63f51.jpg";